import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-06-23
 * @brief SEI 리포트-header 컴포넌트
 *
 ********************************************************************/
import { reportTypeState } from "@recoil/assessmentState";
import { useRecoilState } from "recoil";
// utils
import { useTrans } from "@utils/langs/useTrans";
import dayjs from "dayjs";
function ReportCheckHeader() {
    const t = useTrans();
    // recoil
    const [check, setCheck] = useRecoilState(reportTypeState);
    function CheckClose(e) {
        setCheck(Object.assign(Object.assign({}, check), { checkType: "main", assessmentId: -1, checkSubTypeName: "", checkTypeName: "", checkVersionId: -1, companySpgName: "", itemReportDto: {
                itemId: "",
                itemIdPk: -1,
                itemName: "",
                memo: "",
                responsible: "",
                serialNo: "",
            }, panelName: "", reportId: -1, roomName: "", subZoneName: "", totalComment: "", totalScore: -1, countOpenClose: -1 }));
    }
    return (_jsx(_Fragment, { children: _jsxs("header", { children: [_jsx("div", Object.assign({ className: "header__left" }, { children: check.smenu == "assessment" ? (_jsxs("h1", Object.assign({ className: "header__title" }, { children: [_jsx("strong", { children: `${t("라벨.형명")} : ` + check.itemReportDto.itemName }), _jsxs("span", { children: [t("라벨.시리얼번호"), ": ", check.itemReportDto.serialNo] })] }))) : (_jsx("h1", Object.assign({ className: "header__title bg-no" }, { children: _jsx("span", { children: check.totalInfo.title }) }))) })), _jsxs("div", Object.assign({ className: "header__right" }, { children: [_jsxs("ul", Object.assign({ className: "header__etc" }, { children: [_jsx("li", Object.assign({ className: "date" }, { children: dayjs(new Date()).format("YYYY-MM-DD") })), _jsx("li", { children: _jsx("button", Object.assign({ type: "button", className: "btn-close js-open", "data-pop": "pop-check-close", onClick: (e) => CheckClose(e) }, { children: t("라벨.나가기") })) })] })), _jsx("div", Object.assign({ className: "header__logo" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "LS" })) }))] }))] }) }));
}
export default ReportCheckHeader;
